<template>
  <footer>
    <div class="topline">

    </div>
    <div class="bottom-block">
      <div class="col">
        <div class="logo-wrapper">
          <div class="inside">
            <div class="logo-and-copyright">
              <div class="logo">
                <img src="assets/img/logo.png" alt=""/>
                <div>
                  <h2>
                    KTR
                  </h2>
                  <div class="small">
                    Kiválósági és Támogatási Rendszer
                  </div>
                </div>
              </div>
              <div class="copyright">
                <span>© 2018 Uninet Kft.</span> Minden jog fenntarva.
              </div>
            </div>
          </div>
        </div>
        <div class="menu-wrapper">
          <div class="inside">
            <ul class="menu">
              <li><router-link :to="{ path: '/home' }">Kezdőlap</router-link></li>
              <li><router-link :to="{ path: '/palyazatok' }">Pályázatok</router-link></li>
              <li><a href="/admin" target="_blank">Admin</a></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="photo">

        </div>
      </div>
    </div>

    <div v-if="$root.tmpLoginOpen" style="width: 400px; position: absolute;" class="popup">
      <button type="button" class="close-btn" v-on:click="$root.closeTmpLogin">
        <i class="fa fa-close"></i>
      </button>
      <h1>Bejelentkezés</h1>

      <inputbox id="tmp_login_email" label="Email cím" v-on:onkeydownEnter="tmpLogin" :errors="tmp_login_errors" name="tmp_login_email" v-model="tmp_login_email"></inputbox>

      <div class="form-group">
        <button v-on:click="tmpLogin" type="button" class="button v2">Bejelentkezés</button>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data: function() {
    return {
      tmp_login_email: '',
      tmp_login_errors: [],
    }
  },
  watch: {
    '$route': function() {
      if (this.$route.query.temp == 'qwAyctr52tgh') {
        this.$root.openTmpLogin();
      } else {
        this.$root.closeTmpLogin();
      }
    }
  },
  methods: {
    tmpLogin: function() {
      var _this = this;
      this.tmp_login_errors = [];

      if (this.tmp_login_email == '')
        this.tmp_login_errors.push({id: 'tmp_login_email', msg: 'Kötelező'});

      if (this.tmp_login_errors.length > 0)
        return false;

      this.$root.ajax('users/tmp_login', {
        data: {
          tmp_login_email: this.tmp_login_email
        },
        method: 'POST',
        success: function(response) {
          if (!response.user) {
            _this.tmp_login_errors.push({id: 'tmp_login_email', msg: 'Nem található az adatbázisban a megadott email címmel rendelkező felhasználó'});
          } else {
            _this.$root.user = response.user;
            _this.$root.closeTmpLogin();
            _this.$router.push({path: _this.$root.targetPath});
          }
        },
        error: function(err) {
          console.log(err);
        }
      });
    }
  }
}
</script>


// WEBPACK FOOTER //
// tpl_footer.vue?fa6b9b54